import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import heroPhoto from '../../assets/hero.jpg';
import triciaPhoto from '../../assets/teachers/Tricia_2026.jpg';
import dominiquePhoto from '../../assets/teachers/Dominique_2026.PNG';
import lauraPhoto from '../../assets/teachers/Laura_2026.jpg';
import { PRICING } from '../../data.js';
import './Home.css';

function Home() {
  const API = process.env.REACT_APP_API_URL || "https://iy-sp.com/api";
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem("announcementDismissed")) return;
    fetch(`${API}/settings?studio=flourish`)
      .then(r => r.json())
      .then(d => {
        const s = d.settings ?? d;
        if (s.announcementActive && s.announcementText) {
          setAnnouncement({ text: s.announcementText, url: s.announcementUrl && !/^([a-z]+:|\/)/i.test(s.announcementUrl) ? `https://${s.announcementUrl}` : s.announcementUrl, linkText: s.announcementLinkText });
        }
      })
      .catch(() => {});
  }, [API]);

  return (
    <div className="home">

      {announcement && (
        <div className="home__announcement">
          <span>{announcement.text}{announcement.url && <a className="home__announcement-link" href={announcement.url} target="_blank" rel="noopener noreferrer">{announcement.linkText || "Learn more"} →</a>}</span>
          <button className="home__announcement-dismiss" onClick={() => {
            sessionStorage.setItem("announcementDismissed", "1");
            setAnnouncement(null);
          }}>✕</button>
        </div>
      )}

      <section className="home__hero">
        <div className="home__hero-text">
          <p className="section-label">St. Petersburg, Florida</p>
          <h1 className="home__hero-heading">
            A place to<br />root, grow<br />
            <span className="coral">& flourish</span>
          </h1>
          <p className="home__hero-sub">
            A welcoming studio offering traditional and contemporary yoga for every body and every level.
          </p>
          <div className="home__hero-btns">
            <Link to="/book" className="btn-coral">Book a class</Link>
            <Link to="/classes" className="btn-outline">View schedule</Link>
          </div>
        </div>
        <div className="home__hero-img">
          <img src={heroPhoto} alt="Tricia practising Iyengar yoga" />
        </div>
      </section>

      <section className="home__quote">
        <p className="home__quote-text">
          “Living is an art. <em>Yoga</em> enhances the quality of one’s life. Hence it is an art. It lifts up one’s thoughts and enables one to face life’s difficult situations happily and with equanimity.”
        </p>
        <p className="home__quote-attr">Geeta Iyengar</p>
      </section>

      <section className="home__classes">
        <p className="section-label">What we offer</p>
        <h2 className="section-heading">Find your practice</h2>
        <div className="home__classes-grid">
          <div className="class-card class-card--coral">
            <h3>Iyengar yoga</h3>
            <p>Precise practice, the aim to align body, mind and soul. Therapeutic, beginners, advanced & women's classes available.</p>
          </div>
          <div className="class-card class-card--sage">
            <h3>Hatha & vinyasa</h3>
            <p>Grounded Hatha and dynamic Vinyasa flows for all levels.</p>
          </div>
          <div className="class-card class-card--coral">
            <h3>Restorative & meditation</h3>
            <p>Fluid movement, deep rest, and guided meditation.</p>
          </div>
        </div>
      </section>

      <section className="home__teachers">
        <p className="section-label">The teachers</p>
        <h2 className="section-heading">Meet your guides</h2>
        <div className="home__teachers-grid">
          {[
            { name: 'Tricia',    style: 'Iyengar Yoga',         accent: 'coral',  photo: triciaPhoto },
            { name: 'Dominique', style: 'Vinyasa Flow', accent: 'sage',        photo: dominiquePhoto },
            { name: 'Laura',     style: 'Alignment-based Yoga, Meditative Yoga,', accent: 'coral', photo: lauraPhoto },
            // { name: 'Kelly', style: 'Meditation', accent: 'sage' },
          ].map(t => (
            <div key={t.name} className="teacher-card">
              <div className={`teacher-card__avatar teacher-card__avatar--${t.accent}`}>
                {t.photo && <img src={t.photo} alt={t.name} />}
              </div>
              <p className="teacher-card__name">{t.name}</p>
              <p className="teacher-card__style">{t.style}</p>
            </div>
          ))}
        </div>
        <div className="home__teachers-cta">
          <Link to="/teachers" className="btn-outline">Meet the team</Link>
        </div>
      </section>
      
      <section className="home__passes">
        <p className="section-label">Passes & pricing</p>
        <h2 className="section-heading">Simple, flexible options</h2>
        <p className="home__passes-note">All drop-ins ${PRICING.dropin.price}.</p>
        <div className="home__passes-grid">
          <div className="pass-card">
            <p className="pass-card__label">{PRICING.pass4.label}</p>
            <p className="pass-card__price">${PRICING.pass4.price}</p>
            <p className="pass-card__note">{PRICING.pass4.note}</p>
          </div>
          <div className="pass-card pass-card--featured">
            <div className="pass-card__top">
              <p className="pass-card__label">{PRICING.committed.label}</p>
              <span className="pass-card__badge">{PRICING.committed.badge}</span>
            </div>
            <p className="pass-card__price">${PRICING.committed.price}<span>/month</span></p>
            <p className="pass-card__note">{PRICING.committed.note} - {PRICING.committed.perClassNote}</p>
            <p className="pass-card__note">Discounted access to class recordings</p>
          </div>
          <div className="pass-card">
            <p className="pass-card__label">{PRICING.pass8.label}</p>
            <p className="pass-card__price">${PRICING.pass8.price}</p>
            <p className="pass-card__note">{PRICING.pass8.note}</p>
          </div>
          <div className="pass-card">
            <p className="pass-card__label">{PRICING.monthly.label}</p>
            <p className="pass-card__price">${PRICING.monthly.price}<span>/month</span></p>
            <p className="pass-card__note">{PRICING.monthly.note}</p>
            <p className="pass-card__note">Free access to class recordings</p>
          </div>
        </div>
        <div className="home__passes-cta">
          <Link to="/passes" className="btn-outline">See all options</Link>
        </div>
      </section>

    </div>
  );
}

export default Home;
